
const initialState = {
    apiStatus: "API_IDLE",

    // Cognito
    checkedUserSession: false,
    user: null,

    // Data
    client: null,
    event: null,
    clients: null,
    eventsOverview: null,
    events: null,
    purchases: null
}

const service = (state = initialState, action) => {
    switch (action.type) {
        case 'API_SAVING':
        case 'API_LOADING':
        case 'API_IDLE':
            return { ...state, apiStatus: action.type };
        case 'SIGN_IN':
            return { ...state, apiStatus: "API_IDLE", user: action.data };
        case 'SIGN_OUT':
            return { ...state, apiStatus: "API_IDLE", user: null, checkedUserSession: false };
        case 'CHECK_USER_SESSION':
            return { ...state, apiStatus: "API_IDLE", user: action.data, checkedUserSession: true };
        case "FETCH_EVENT":
            let client = action.data ? action.data.client : null
            let event = action.data ? action.data.event : null
            return { ...state, client: client, event: event }
        case "FETCH_CLIENT_AND_EVENT":
            return { ...state, client: action.data ? action.data.client : null, event: action.data ? action.data.event : null }
        case "FETCH_CLIENTS":
            return { ...state, clients: action.data, event: state.event }
        case "FETCH_PAST_EVENTS":
            console.log(action.data)
            return { ...state, events: action.data ? action.data.events : null, client: action.data ? action.data.client : null, event: state.event }
        case "FETCH_EVENTS_OVERVIEW":
            return { ...state, eventsOverview: action.data ? action.data.events : null, event: state.event }
        case "SEARCH_PURCHASES":
        case "GET_EVENT_PURCHASES":
            return { ...state, purchases: action.data }
        default:
            return state;
    }
}

export default service
